import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex'
  },
  containerDelete: {
    display: 'flex',
    alignItems: 'center'
  },
  containerList: {
    width: '100%',
    cursor: 'pointer',
    backgroundColor: '#F2F3F4',
    '&:hover': {
      backgroundColor: '#EAEDED'
    }
  },
  delete: {
    display: 'block'
  },
  labels: {
    display: 'flex',
    marginBottom: 15,
    marginLeft: 10
  },
  title: {
    fontWeight: 'bold',
    marginBlock: 10,
    marginLeft: 10
  },
  separator: {
    backgroundColor: 'black',
    border: 0,
    height: 1
  },
  nameStyle: {
    display: 'flex'
  }
}))

export default useStyles
